import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class modReportsHub_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return `
            <div class="mod-reports-hub">
                <!-- p class="mod-reports-hub-intro">Choose a report:</p -->
                <div class="w-list-results">
                    <table class="list-results">
                        <thead>
                            <tr>
                                <th>Report</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><a class="right-click" href="/mods/reports/daily-downloads/">Daily downloads</a></td>
                                <td><a class="right-click" href="/mods/reports/daily-downloads/">Total and unique downloads by calendar day</a></td>
                            </tr>
                            <tr>
                                <td><a class="right-click" href="/mods/reports/daily-uploads/">Daily uploads</a></td>
                                <td><a class="right-click" href="/mods/reports/daily-uploads/">Mod records created by calendar day</a></td>
                            </tr>
                            <tr>
                                <td><a class="right-click" href="/mods/reports/game-downloads-per-period/">Game downloads per period</a></td>
                                <td><a class="right-click" href="/mods/reports/game-downloads-per-period/">Total and unique downloads grouped by game</a></td>
                            </tr>
                            <tr>
                                <td><a class="right-click" href="/mods/reports/daily-signups/">Daily signups</a></td>
                                <td><a class="right-click" href="/mods/reports/daily-signups/">New access-point users by calendar day (GGMods access point)</a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "modReportsHub_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): string[] {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        return {};
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/modReportsHub_template.ts